import { render, staticRenderFns } from "./AppTips.vue?vue&type=template&id=3c54dbd9&"
import script from "./AppTips.vue?vue&type=script&lang=js&"
export * from "./AppTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports